module.exports = __webpack_public_path__ + "static/media/chill-spins-600x200-transparent.cd644662.png";